import { defineStore } from 'pinia'
import { request } from '../../api'

export const useSurfaceDesignColorsStore = defineStore('surfaceDesignColors', {
  state: () => ({
    list: null,
    count: -1,
    items: null,
    itemsCount: -1,
    collectionsParams: {
      limit: 20,
      offset: 0,
      q: '',
      personal: 1,
      sortDirection: 'asc',
      sortField: 'updatedAt',
    },
    itemsParams: {
      limit: 20,
      offset: 0,
      q: '',
      sortDirection: 'asc',
      sortField: '',
      collection: '',
    },
    createNextStep: null,
    initCreateModal: false,
    importModal: false,
    commitModal: false,
    createModal: false,
    renameModal: false,
    delCollectionModal: false,
    delTeamCollectionModal: false,

    renameItemModal: false,
    delItemModal: false,

    collectionName: '',
    collectionId: null,

    itemName: '',
    itemId: null,
    changeItem: null,

    selectedCollectionId: null,
    selectedCollectionName: null,
    selectedCollection: null,
    oneCollection: null,

    csvFile: null,
    csvFileInfo: {
      delimiter: '',
    },
    changedDelimiter: false,

    columnsImportOptions: [
      { value: 'name', title: 'Color name' },
      { value: 'hex', title: 'HEX code' },
      { value: 'rgb', title: 'RGB code' },
      { value: 'pantone', title: 'Pantone' },
      { value: '', title: 'Do not import' },
    ],

    loading: false,
    csvLoading: false,
    invalidFileType: false,
    requiredFieldError: false,
    csvError: false,

    palette: [],
    deletedItems: [],
    collumnCount: null,
  }),
  getters: {
    delimiterOk: (state) => {
      return (state.changedDelimiter && (state.csvFileInfo.delimiter === ',' || state.csvFileInfo.delimiter === ';')) || !state.changedDelimiter
    },
    canSave: (state) => {
      const noName = state.palette.find(el => el.hex && !el.name)
      if (noName) return false
      const isNew = !!state.palette?.find(el => el.hex && !el.id && !el.error && !el.double) || state.deletedItems.length
      let isOld = false
      state.palette.forEach(el => {
        if (el.id && state.items) {
          const color = state.items.find(e => e.id === el.id)
          let name = color?.name || ''
          let hex = color?.hex || ''
          if ((el.name !== name || el.hex !== hex) && !el.error && !el.double) isOld = true
        }
      })
      return isNew || isOld
    },
    selectedCols: (state) => {
      const cols = state.csvFileInfo?.cols
      if (cols === undefined) return []
      const keys = Object.keys(cols)
      return keys.map(key => cols[key])
    },
    selectedColsIsUniq: (state) => {
      const duplicates = state.selectedCols.filter((item, index) => state.selectedCols.indexOf(item) !== index)
      return duplicates.every(col => col === '')
    },
    selectedColsIsValid: (state) => {
      return state.selectedCols.some(col => col === 'rgb') ||
             state.selectedCols.some(col => col === 'hex') ||
             state.selectedCols.some(col => col === 'pantone')
    },
  },
  actions: {
    async savePallete (router) {
      this.loading = true
      if (this.deletedItems.length) {
        await request.delete(`/surface/colors/${this.deletedItems[0]}`)
        this.deletedItems.splice(0, 1)
        this.savePallete(router)
        return
      }
      for (let index = 0; index < this.palette.length; index++) {
        const item = this.palette[index]
        if (item.hex && !item.id) {
          await request.post(
            '/surface/colors', JSON.stringify({
              name: item.name,
              hex: item.hex,
              rgb: item.rgb,
              collection: this.selectedCollectionId,
            }),
            { headers: { 'Content-Type': 'application/json; charset=UTF-8' } },
          )
            .then(response => {
              const updatedFiles = [...this.palette]
              updatedFiles[index] = {
                ...updatedFiles[index],
                id: response.data.id,
              }
              this.palette = updatedFiles
            })
            .catch(error => {
              const updatedFiles = [...this.palette]
              updatedFiles[index] = {
                ...updatedFiles[index],
                error: error.response.data.message,
              }
              this.palette = updatedFiles
            })
        } else if (item.id) {
          const color = this.items?.find(el => el.id === item.id)
          if (item?.hex !== color?.hex || item?.name !== color?.name) {
            await request.put(
              '/surface/colors/' + item.id, JSON.stringify({
                hex: item.hex,
                rgb: item.rgb,
                name: item.name,
                collection: this.selectedCollectionId,
              }),
              { headers: { 'Content-Type': 'application/json; charset=UTF-8' } },
            )
              .catch(error => {
                const updatedFiles = [...this.palette]
                updatedFiles[index] = {
                  ...updatedFiles[index],
                  error: error.response.data.message,
                }
                this.palette = updatedFiles
              })
          }
        }
      }
      const isError = this.palette.find(el => el.error)
      this.loading = false
      if (!isError) router.push(`/user/surface-design-color/${this.selectedCollectionId}`)
    },
    async delColor (index) {
      const updatedFiles = [...this.palette]
      if (updatedFiles[index].id) this.deletedItems.push(updatedFiles[index].id)
      updatedFiles[index] = { rgb: null, hex: null, name: '', error: null, id: null, double: false }
      this.palette = updatedFiles
      this.makeImgArray()
    },
    makeFullImgArray () {
      const updatedFiles = this.palette.filter(el => el.hex && el.name)
      this.palette = updatedFiles
    },
    makeImgArray () {
      const isNotFull = this.palette.find(el => !el.hex)
      if (this.items && !isNotFull && !this.palette.length) {
        this.items.forEach(el => {
          this.palette.push({
            id: el.id,
            name: el.name,
            rgb: el.rgb,
            hex: el.hex,
            error: null,
            double: false,
          })
        })
      }
      if (!this.palette.length || !isNotFull) {
        const remainder = this.palette.length % this.collumnCount
        const needCount = remainder === 0 ? this.collumnCount : this.collumnCount - remainder
        this.palette.push(
          ...Array(needCount).fill(null).map(() => ({ rgb: null, hex: null, name: '', error: null, id: null, double: false })),
        )
      }
    },
    addCSV (e) {
      const file = e.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = () => {
          this.csvFile = {
            name: file.name,
            type: file.type,
            file,
          }
        }
      }
    },

    removeCSV () {
      this.csvFile = null
    },

    async prepareCSV () {
      try {
        this.csvLoading = true
        this.invalidFileType = false
        const form = new FormData()
        form.append('delimiter', this.csvFileInfo.delimiter)
        form.append('file', this.csvFile.file, 'data.csv')

        const req = await fetch(
          process.env.VUE_APP_BASE_URL + '/surface/colors/csv',
          {
            method: 'PUT',
            headers: {
              'Authorization': 'Bearer ' + localStorage?.getItem?.('token'),
            },
            body: form,
          },
        )
        const res = await req.json()
        if (req.ok) {
          const { cols, rows } = res
          this.csvFileInfo.cols = cols
          this.csvFileInfo.rows = rows
          this.csvLoading = false
          this.importModalToggle()
          this.commitImportModalToggle()
        } else {
          this.csvLoading = false
          if (res.message === 'Wrong file type') this.invalidFileType = true
        }
      } catch (e) {
        this.csvLoading = false
      }
    },

    async importCSV (router) {
      try {
        this.requiredFieldError = false
        this.csvLoading = true

        const keys = Object.keys(this.csvFileInfo.cols)
        const selectedCols = {}
        let isRequired = keys.find(el => ['hex', 'rgb', 'pantone'].includes(this.csvFileInfo.cols[el]))
        let isHasName = keys.find(el => this.csvFileInfo.cols[el] === 'name')
        if (!isRequired || !isHasName) {
          this.requiredFieldError = true
          return
        }
        keys.forEach(k => {
          if (this.csvFileInfo.cols[k] !== '') selectedCols[k] = this.csvFileInfo.cols[k]
        })

        const form = new FormData()
        form.append('file', this.csvFile.file, 'data.csv')
        form.append('cols', JSON.stringify(selectedCols))
        form.append('delimiter', this.csvFileInfo.delimiter)
        form.append('collection', this.selectedCollectionId)
        await request.patch('/surface/colors/csv',
          form,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            transformRequest: [(data) => data],
          })
          .then(response => {
            this.csvLoading = false
            router.push({ name: 'surfaceDesignColor', params: { id: this.selectedCollectionId } })
            this.$reset()
          })
          .catch(error => {
            this.csvError = true
            this.commitImportModalToggle()
            this.csvLoading = false
            console.log(error)
          })
      } catch (e) {
        this.csvLoading = false
      }
    },

    selectCollectionId (collectionId) {
      this.selectedCollectionId = collectionId
    },
    selectCollectionName (name) {
      this.selectedCollectionName = name
    },
    selectCollection (collection) {
      this.selectedCollection = collection
    },
    initCreateModalToggle () {
      this.initCreateModal = !this.initCreateModal
      this.createNextStep = null
      this.collectionName = ''
    },
    setCreateNextStep (value) {
      this.initCreateModal = !this.initCreateModal
      this.createNextStep = value
      this.createModalToggle()
    },
    goToCreateNextStep (router) {
      if (this.createNextStep === 'create') router.push({ name: 'surfaceDesignColorsNew' })
      if (this.createNextStep === 'import') this.importModalToggle()
      this.createNextStep = null
    },
    closeCsvErrorModal () {
      this.csvError = false
      this.removeCSV()
    },
    closeImportModal () {
      this.importModal = false
      this.changedDelimiter = false
      this.csvFileInfo.delimiter = ''
      this.removeCSV()
      this.invalidFileType = false
    },
    importModalToggle () {
      this.importModal = !this.importModal
    },
    commitImportModalToggle () {
      this.commitModal = !this.commitModal
    },
    anotherFileModalToggle () {
      this.csvLoading = false
      this.commitImportModalToggle()
      this.importModalToggle()
    },
    createModalToggle () {
      this.createModal = !this.createModal
      this.collectionName = ''
    },
    renameModalToggle () {
      this.renameModal = !this.renameModal
      this.collectionId = null
      this.collectionName = ''
    },
    delCollectionModalToggle () {
      this.delCollectionModal = !this.delCollectionModal
      this.collectionId = null
    },
    renameItemModalToggle () {
      this.renameItemModal = !this.renameItemModal
      this.itemId = null
      this.itemName = ''
    },
    delItemModalToggle () {
      this.delItemModal = !this.delItemModal
      this.itemId = null
    },
    async setSortOrderCollections (order) {
      this.collectionsParams.sortDirection = order
      await this.getList()
    },
    async searchByCollections (search) {
      this.collectionsParams.q = search
      this.collectionsParams.offset = 0
      await this.getList()
    },
    async sortCollection (sort) {
      this.collectionsParams.sortField = sort
      this.collectionsParams.offset = 0
      await this.getList()
    },
    async setSortOrderItems (order, id) {
      this.itemsParams.sortDirection = order
      this.itemsParams.offset = 0
      await this.getItems(id)
    },
    async searchByItems (search, id) {
      this.itemsParams.q = search
      this.itemsParams.offset = 0
      await this.getItems(id)
    },
    async sortItems (sort, id) {
      this.itemsParams.sortField = sort
      this.itemsParams.offset = 0
      await this.getItems(id)
    },
    async getList () {
      this.loading = true
      try {
        const { data: { rows: list, count } } = await request.get(
          '/surface/colors-collections',
          { params: this.collectionsParams },
        )
        this.list = list
        this.count = count
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    async getCollection (id) {
      try {
        const { data } = await request.get('/surface/colors-collections/' + id)
        this.oneCollection = data
      } catch (e) {
        console.error(e.message)
      }
    },
    clearFiles () {
      this.palette = []
      this.items = null
    },
    async create (router) {
      try {
        const { data } = await request.post(
          '/surface/colors-collections',
          JSON.stringify({ title: this.collectionName }),
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
          },
        )
        this.collectionName = ''
        this.selectCollection(data)
        this.selectCollectionId(data.id)
        this.createModalToggle()
        await this.getList()
        this.selectCollectionName(data.title)
        this.clearFiles()
        this.goToCreateNextStep(router)
      } catch (e) {
        console.error(e.message)
      }
    },
    async updateCollection () {
      try {
        await request.put(
          '/surface/colors-collections/' + this.collectionId,
          JSON.stringify({ title: this.collectionName }),
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
          },
        )
        await this.getList()
        this.renameModalToggle()
        this.collectionId = null
        this.collectionName = ''
      } catch (e) {
        console.error(e.message)
      }
    },
    async deleteCollection () {
      try {
        await request.delete('/surface/colors-collections/' + this.collectionId)
        await this.getList()
        this.delCollectionModalToggle()
        this.collectionId = null
      } catch (e) {
        console.error(e.message)
      }
    },

    async getItems (id) {
      try {
        this.itemsParams.collection = id
        const { data: { rows: items, count } } = await request.get(
          '/surface/colors',
          { params: this.itemsParams },
        )
        this.items = items
        this.itemsCount = count
      } catch (e) {
        console.error(e.message)
      }
    },

    async updateItem (collectionId) {
      try {
        await request.put(
          '/surface/colors/' + this.itemId,
          JSON.stringify({
            ...this.changeItem,
            designName: this.designName,
            designCategory: this.changeItem.categoryCode,
            elementIds: this.changeItem.elements.join(','),
            ease: JSON.stringify(this.changeItem.ease),
            fabricType: String(this.changeItem.fabricType),
            fit: String(this.changeItem.fit),
            collectionId: String(this.changeItem.collection),
            mannequinEase: JSON.stringify(this.changeItem.mannequinEase),
          }),
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
          },
        )
        await this.getItems(collectionId)
        this.renameItemModalToggle()
        this.itemId = null
        this.itemName = ''
      } catch (e) {
        console.error(e.message)
      }
    },
    async deleteItem (collectionId) {
      try {
        await request.delete('/surface/colors/' + this.itemId)
        await this.getItems(collectionId)
        this.delItemModalToggle()
        this.itemId = null
      } catch (e) {
        console.error(e.message)
      }
    },
  },
})
